/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Edit_ConditionsInputs */

const en_case_payment_edit_conditions = /** @type {(inputs: Case_Payment_Edit_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit payment conditions`)
};

const pt_br2_case_payment_edit_conditions = /** @type {(inputs: Case_Payment_Edit_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar condições de pagamento`)
};

/**
* | output |
* | --- |
* | "Edit payment conditions" |
*
* @param {Case_Payment_Edit_ConditionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_edit_conditions = /** @type {((inputs?: Case_Payment_Edit_ConditionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Edit_ConditionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_edit_conditions(inputs)
	return pt_br2_case_payment_edit_conditions(inputs)
});